import { Button } from "@/components/ui/button";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { debounce, throttle } from "radashi";

export const Route = createFileRoute("/lab/mutation-throttle")({
  component: RouteComponent,
});

function RouteComponent() {
  const regular = useMutation({
    mutationKey: ["mutation-regular"],
    mutationFn: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          console.log(Date.now());
          resolve("mutated");
        }, 1000);
      });
    },
  });

  const throttled = useMutation({
    mutationKey: ["mutation-throttled"],
    mutationFn: () => {
      console.log(Date.now());
      return Promise.resolve("mutated");
    },
  });
  const mutateThrottled = throttle({ interval: 5000 }, throttled.mutate);

  const debounced = useMutation({
    mutationKey: ["mutation-debounced"],
    mutationFn: () => {
      console.log(Date.now());
      return Promise.resolve("mutated");
    },
  });
  const mutateDebounced = debounce({ delay: 1000 }, debounced.mutate);

  return (
    <div>
      <h1>Mutation Throttle</h1>
      <Button onClick={() => regular.mutate()} disabled={regular.isPending}>
        Regular (one parallel)
      </Button>
      <Button onClick={() => mutateThrottled()} disabled={throttled.isPending}>
        Throttled (5s)
      </Button>
      <Button onClick={() => mutateDebounced()} disabled={debounced.isPending}>
        Debounced (1s)
      </Button>
    </div>
  );
}
